// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  BASE_URL: 'https://cctv-brtv-api-3a7d49ea00ae.herokuapp.com/',
  //BASE_URL: 'http://localhost:8000/',
  CLIENT_API: 'https://us-west-2.aws.data.mongodb-api.com/app/cetv-ads-mammoth-qtgpyqe/endpoint/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
